import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

export default function PopupCard() {
  const navigate = useNavigate();
  const FIRST_SHOW_DELAY_MS = 10000; // pehli baar 10 seconds baad
  const RESHOW_DELAY_MS = 30000; // band karne ke 30 seconds baad phir se
  const [isVisible, setIsVisible] = useState(false);
  const timerRef = useRef(null);

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    // Pehli baar: website open hone ke 10 seconds baad popup dikhao
    timerRef.current = setTimeout(() => {
      setIsVisible(true);
    }, FIRST_SHOW_DELAY_MS);

    return () => clearTimer();
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    clearTimer();
    // 30 seconds baad phir se popup dikhao
    timerRef.current = setTimeout(() => {
      setIsVisible(true);
    }, RESHOW_DELAY_MS);
  };

  const handleBuyNow = () => {
    setIsVisible(false);
    clearTimer();
    navigate("/counter");
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop blur - full screen overlay */}
      <div 
        className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm cursor-pointer"
        onClick={handleClose}
      />

      {/* Popup Card - Centered on screen */}
      <div 
        className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none"
        onClick={handleClose}
      >
        <div 
          className="relative w-full max-w-[420px] animate-[scale-in_0.3s_ease-out] rounded-3xl bg-gradient-to-br from-[#2D1B4E] to-[#1A2F5C] p-8 shadow-2xl pointer-events-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <button
            onClick={handleClose}
            className="absolute right-4 top-4 rounded-full bg-white/10 p-2 text-white transition hover:bg-white/20 hover:rotate-90 duration-300"
            aria-label="Close popup"
          >
            <X size={20} />
          </button>

          {/* Image */}
          <div className="flex justify-center">
            <img
              src="/images/dolarbox.png"
              alt="Bonus Box"
              className="h-56 pl-12 w-auto object-contain sm:h-64"
            />
          </div>

          {/* Content */}
          <div className="text-center">
            <h2 className="mb-4 text-2xl font-bold text-white sm:text-3xl">
              Get bonus invest now
            </h2>
            <p className="text-base text-white/80 sm:text-lg">
              Purchase{" "}
              <span className="font-semibold text-purple-400">$100</span> worth
              of coin
            </p>
            <p className="mt-2 text-base text-white/80 sm:text-lg">
              Receive and additional{" "}
              <span className="font-semibold text-purple-400">10,000 coin</span>
            </p>
          </div>

          {/* Buy Now Button */}
          <div className="mt-6">
            <button
              onClick={handleBuyNow}
              className="w-full rounded-lg bg-gradient-to-r from-[#8C3CDD] to-[#A367FF] py-3 text-base font-semibold text-white shadow-[0_8px_24px_rgba(140,60,221,0.4)] transition hover:shadow-[0_12px_32px_rgba(140,60,221,0.6)] hover:scale-[1.02] active:scale-[0.98]"
            >
              Buy now
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scale-in {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </>
  );
}
